import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  creation: {
    objectives: [],
    originalData: null,
  },

  update: {
    objectives: [],
    hasChanges: false,
    changedObjectives: {},
  },

  display: {
    objectives: [],
    loading: false,
    error: null,
  },
};

const projectObjectiveSlice = createSlice({
  name: "projectObjective",
  initialState,
  reducers: {
    // Creation actions
    updateCreationObjectives: (state, action) => {
      state.creation.objectives = action.payload;
    },
    addCreationObjective: (state, action) => {
      state.creation.objectives.push(action.payload);
    },
    removeCreationObjective: (state, action) => {
      state.creation.objectives = state.creation.objectives.filter(
        (obj) => obj.id !== action.payload,
      );
    },
    updateCreationObjective: (state, action) => {
      const { id, data } = action.payload;
      const index = state.creation.objectives.findIndex((obj) => obj.id === id);
      if (index !== -1) {
        state.creation.objectives[index] = {
          ...state.creation.objectives[index],
          ...data,
        };
      }
    },
    resetCreation: (state) => {
      state.creation = initialState.creation;
    },
    loadCreationData: (state, action) => {
      state.creation.objectives = action.payload || [];
    },
    setCreationOriginalData: (state, action) => {
      state.creation.originalData = action.payload;
    },

    // Update actions
    updateUpdateObjectives: (state, action) => {
      state.update.objectives = action.payload;
      state.update.hasChanges = true;
    },
    addUpdateObjective: (state, action) => {
      state.update.objectives.push(action.payload);
      state.update.hasChanges = true;
    },
    removeUpdateObjective: (state, action) => {
      state.update.objectives = state.update.objectives.filter(
        (_, index) => index !== action.payload,
      );
      state.update.hasChanges = true;
    },
    updateUpdateObjective: (state, action) => {
      const { index, data } = action.payload;
      if (state.update.objectives[index]) {
        state.update.objectives[index] = {
          ...state.update.objectives[index],
          ...data,
        };
        state.update.hasChanges = true;
        state.update.changedObjectives[index] = true;
      }
    },
    loadUpdateData: (state, action) => {
      state.update.objectives = action.payload;
      state.update.hasChanges = false;
      state.update.changedObjectives = {};
    },
    clearUpdateChanges: (state) => {
      state.update.hasChanges = false;
      state.update.changedObjectives = {};
    },
    resetUpdate: (state) => {
      state.update = initialState.update;
    },

    // Display actions
    setDisplayData: (state, action) => {
      state.display.objectives = action.payload;
      state.display.loading = false;
      state.display.error = null;
    },
    setDisplayLoading: (state, action) => {
      state.display.loading = action.payload;
    },
    setDisplayError: (state, action) => {
      state.display.error = action.payload;
      state.display.loading = false;
    },
    resetDisplay: (state) => {
      state.display = initialState.display;
    },
  },
});

export const {
  updateCreationObjectives,
  addCreationObjective,
  removeCreationObjective,
  updateCreationObjective,
  loadCreationData,
  setCreationOriginalData,
  updateUpdateObjectives,
  addUpdateObjective,
  removeUpdateObjective,
  updateUpdateObjective,
  loadUpdateData,
  clearUpdateChanges,
  resetCreation,
  resetUpdate,
  setDisplayData,
  setDisplayLoading,
  setDisplayError,
  resetDisplay,
} = projectObjectiveSlice.actions;

export default projectObjectiveSlice.reducer;
